'use client';

import { PendingInvitationModal as PendingInvitationModalComponent } from '@pickleballinc/ui/components/team-leagues/prints/modals/PendingInviteModal';
import { useRouter } from 'next/navigation';
import { useEffect, useState } from 'react';

import { getRedirectUrl } from '@/components/organisms/modals/utils/getRedirectUrl';
import { TeamLeagueOutstandingInvoice } from '@/infrastructure/dto/OutstandingInvoicesDto';
import { dismissModal, isModalDismissed } from '@/lib/cookies';

interface PendingInvitationModalProps {
	invoice: TeamLeagueOutstandingInvoice;
}

export const PendingInvitationModal = ({ invoice }: PendingInvitationModalProps) => {
	const router = useRouter();
	const [isOpen, setIsOpen] = useState(false);
	const modalId = `team_league_team_invitation_${invoice.teamLeagueUuid}_${invoice.teamUuid}`;

	useEffect(() => {
		// Check if modal was dismissed in the last 24 hours
		if (!isModalDismissed(modalId)) {
			setIsOpen(true);
		}
	}, [modalId]);

	const handleClose = () => {
		dismissModal(modalId);
		setIsOpen(false);
	};

	const handleContinue = () => {
		dismissModal(modalId);
		setIsOpen(false);
		const url = getRedirectUrl(invoice);
		router.push(url);
	};

	return <PendingInvitationModalComponent invoice={invoice} open={isOpen} onClose={handleClose} onContinue={handleContinue} />;
};
